import React from "react";
import { Select, SelectOption } from "@moai/core";
import * as clipboard from "clipboard-polyfill";
import FileSaver from "file-saver";
import s from "./save.module.scss";

interface Props {
    getValue: () => string | null;
}

type Target = "none" | "clipboard" | "file";

const blobOptions: BlobPropertyBag = {
    type: "text/json;charset=utf-8",
};

const targets: SelectOption<Target>[] = [
    { value: "none", label: "Save", disabled: true },
    { value: "clipboard", label: "Copy to clipboard" },
    { value: "file", label: 'Download as file' },
];

export const SaveMenu: React.FC<Props> = ({ getValue }) => {
    const setTarget = (target: Target) => {
        const value = getValue() || "";
        switch (target) {
            case "clipboard":
                clipboard.writeText(value).catch((e) => {
                    window.alert(`Cannot copy: ${e.message}`);
                });
                break;
            case "file":
                const blob = new Blob([value], blobOptions);
                FileSaver.saveAs(blob, "untitled.json");
                break;
            case "none":
                throw Error('Should not reach "none"');
        }
    };

    return (
        <div className={s.container}>
            <Select
                fullWidth
                value="none"
                setValue={setTarget}
                options={targets}
            />
        </div>
    );
};
